<script>
import Swal from "sweetalert2";

import router from "@/router";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Form from '@/components/proposals/form'

export default {
    page: {
    title: "Edit Proposal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Form
  },
  async mounted() {
    this.apiGet(`/proposals/${this.$route.params.id}`, { include: 'advertiser,deleted' }).then((data) => {
      this.proposal = data;
    }).catch((error) => {
      if (error) {
        this.$store.dispatch('layout/addPageError', error);
      }
    })
  },
  data() {
    return {
      title: "Edit proposal",
      proposal: null
    }
  },
  computed: {
    items() {
      if (this.proposal) {
        return [
        {
          text: "Proposals",
          href: "/proposals",
        },
        {
          text: this.proposal.name,
        },
        {
          text: "Edit",
          active: true
        }
      ]
      } else {
        return []
      }
    }
  },
  methods: {
    tiggerExit() {
      Swal.fire({
        title: "Are you sure?",
        text: "Any unsaved progress will be lost",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1D99C7",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, exit"
      }).then(result => {
        if (result.value) {
          router.push({ path: '/proposals' })
        }
      });
    },
    handleClone() {
      this.apiPost(`/proposals/${this.$route.params.id}/clone`).then(() => {
        this.$bvToast.toast('Proposal has now been cloned', {
          title: 'Proposal Cloned',
          variant: 'success',
          solid: true
        });
      }).catch(() => {
        this.$bvToast.toast('This proposal can\'t be cloned at this time', {
          title: 'Error Cloning Proposal',
          variant: 'warning',
          solid: true
        });
      });
    },
    handleArchive() {
      this.apiDelete(`/proposals/${this.$route.params.id}`).then(() => {
        this.proposal.deletedAt = 'now';
  
        this.$bvToast.toast('Proposal has now been archived', {
          title: 'Proposal Archived',
          variant: 'success',
          solid: true
        });
      }).catch(() => {
        this.$bvToast.toast('This proposal can\'t be archived at this time', {
          title: 'Error Archiving Proposal',
          variant: 'warning',
          solid: true
        });
      });
    },
    handleUnarchive() {
      this.apiUndelete(`/proposals/${this.$route.params.id}`).then(() => {
        this.proposal.deletedAt = null;

        this.$bvToast.toast('Proposal has now been unarchived', {
          title: 'Proposal Unrchived',
          variant: 'success',
          solid: true
        });
      }).catch(() => {
        this.$bvToast.toast('This proposal can\'t be unarchived at this time', {
          title: 'Error Unarchiving Proposal',
          variant: 'warning',
          solid: true
        });
      });
    },
  }
}

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mb-3" v-if="proposal">
      <div class="col-12 text-right">
        <b-button variant="outline-primary" class="w-sm" @click="tiggerExit">
          <i class="bx bx-chevron-left font-size-16 align-middle mr-2" /> Exit
        </b-button>
        <b-button variant="primary" @click="handleClone" v-if="proposal && proposal.status === 'Active'" class="ml-2 w-sm">
          <i class="bx bx-repeat text-white font-size-16 align-middle mr-1"></i>
          Clone Proposal
        </b-button>
        <b-button variant="danger" class="ml-2" @click="handleArchive" v-if="proposal && !this.proposal.deletedAt">
          <i class="bx font-size-16 align-middle mr-2 bxs-archive-in" />
          Archive Proposal
        </b-button>
        <b-button variant="success"  class="ml-2" @click="handleUnarchive" v-else-if="proposal && this.proposal.deletedAt">
          <i class="bx font-size-16 align-middle mr-2 bxs-archive-out" />
          Unarchive Proposal
        </b-button>

      </div>
    </div>
    <Form v-if="proposal" update :proposal="proposal" />
  </Layout>
</template>